module.exports = __webpack_public_path__ + "f48cdb78dfa71ba03052b57a5715a6b7.jpg";